export default __webpack_public_path__ + "static/media/2.071aeed7.png";